import React from 'react';
import { motion } from 'framer-motion';
import styles from './Question.module.css';

function Question({ title, isLong, questionFontSize }) {
  return (
    <motion.div
      className={styles.block}
      initial={{ x: '100vw' }}
      animate={{ x: 0 }}
      transition={{ duration: 0.56 }}
      key={title}>
      <div className={styles.question}>
        <p
          style={{
            fontSize: isLong
              ? `${0.8 * questionFontSize}rem`
              : `${questionFontSize}rem`,
            lineHeight: isLong
              ? `${0.8 * 1.4 * questionFontSize}rem`
              : `${1.4 * questionFontSize}rem`,
          }}>
          {title}
        </p>
      </div>
    </motion.div>
  );
}

export default Question;
